@if (hasBox()) {
  <rt-box layout-vertical>
    <ng-container [ngTemplateOutlet]="fieldContent" />
  </rt-box>
} @else {
  <ng-container [ngTemplateOutlet]="fieldContent" />
}

<ng-template #fieldContent>
  <rt-form-field>
    @if (labelKey()) {
      <rt-label>{{ labelKey()! | translate }}</rt-label>
    }

    <rt-offer-select
      [formControl]="control()"
      [offers]="offers()"
      [hasSearch]="false"
      [hasInputTrigger]="true"
      [includeEmptyOption]="false"
      [placeholder]="'app.interview.job_placeholder' | translate"
      [class.select-shadow]="selectShadow()"
    />
  </rt-form-field>
</ng-template>
